<ng-container [formGroup]="form">
  <div [ngClass]="columnClass">
    <div class="form-group mb-3">
      <label for="productCategory" class="form-label">{{ labels.productCategory }} <span class="ast">*</span></label>
      <select
        id="productCategory"
        class="form-control"
        formControlName="productCategory"
        [class.is-invalid]="isFieldInvalid('productCategory')">
        <option value="" disabled selected>{{ loadingInsuranceTypes ? messages.loading : placeholders.selectProductCat }}</option>
        <option *ngFor="let type of insuranceTypes" [value]="type.DisplayName">
          {{ type.DisplayName }}
        </option>
      </select>
      <div class="invalid-feedback" *ngIf="isFieldInvalid('productCategory')">
        {{ messages.fieldRequired }}
      </div>
    </div>
  </div>

  <div [ngClass]="columnClass" *ngIf="form.get('productCategoryId')?.value === 'other'">
    <div class="form-group mb-3">
      <label for="otherInsurance" class="form-label">{{ labels.pleaseSpecify }} <span class="ast">*</span></label>
      <input
        type="text"
        id="otherInsurance"
        class="form-control"
        formControlName="otherInsurance"
        [class.is-invalid]="isFieldInvalid('otherInsurance')"
        placeholder="{{ placeholders.enterProductCat }}"
        maxlength="200">
      <div class="invalid-feedback" *ngIf="isFieldInvalid('otherInsurance')">
        {{ messages.fieldRequired }}
      </div>
    </div>
  </div>

  <div [ngClass]="columnClass" *ngIf="form.get('productCategoryId')?.value !== 'other' && (loadingProducts || hasAvailableProducts())">
    <div class="form-group mb-3">
      <label for="product" class="form-label">{{ labels.product }} <span class="ast">*</span></label>
      <select
        id="product"
        class="form-control"
        formControlName="product"
        [class.is-invalid]="isFieldInvalid('product')">
        <option value="" disabled selected>{{ loadingProducts ? messages.loading : placeholders.selectProduct }}</option>
        <option *ngFor="let product of products" [value]="product.DisplayName">
          {{ product.DisplayName }}
        </option>
      </select>
      <div class="invalid-feedback" *ngIf="isFieldInvalid('product')">
        {{ messages.fieldRequired }}
      </div>
    </div>
    <div class="form-group mb-3" *ngIf="form.get('productId')?.value === 'other'">
      <label for="otherProduct" class="form-label">{{ labels.pleaseSpecify }} <span class="ast">*</span></label>
      <input
        type="text"
        id="otherProduct"
        class="form-control"
        formControlName="otherProduct"
        [class.is-invalid]="isFieldInvalid('otherProduct')"
        placeholder="{{ placeholders.enterProductName }}"
        maxlength="200">
      <div class="invalid-feedback" *ngIf="isFieldInvalid('otherProduct')">
        {{ messages.fieldRequired }}
      </div>
    </div>
  </div>
</ng-container>
